import store from '../../../store'

export default {
  orderById: 223,
  elementType: 'CascadeBox',
  baseElementType: 'CASCADE',
  elementDesc: '级联题',
  type: 'selectbox',
  // 是否可配置
  config: true,
  title: '城市选择',
  placeholder: '',
  visibility: '0',
  toolbar: {
    config: false
  },
  paramInt01: '3',
  value: '',
  textValue: '',
  otherAnswer: '',
  saveCb (data) {
    this.optionList = data.optionList
    const surveyAnswer = store.getters.surveyAnswer
    if (surveyAnswer && surveyAnswer.answerListObj) {
      const answerData = surveyAnswer.answerListObj.find(item => (item.quId === data.id))
      if (answerData) {
        this.textValue = answerData.screenData
        if (data.answerList && data.answerList.length) {
          const selData = data.answerList[0]
          this.value = selData.answer ? selData.answer.split(',') : ''
        }
      }
    }
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/CascadeBox/config.js